// extracted by mini-css-extract-plugin
module.exports = {"container":"Warranty_container__1fhPx"};